import React, { useState } from "react";

const FontSelector = (props) => {
  const { items } = props;
  const defaultStyle = {
    border: "none",
    borderBottom: "1px solid black",
    outline: "none",
    width: "100%",
    padding: "4px 4px 40px 4px",
    fontSize: "40px",
    lineHeight: "1.5em",
    fontFamily: "ToyotaType",
  };
  const [fontStyle, setFontStyle] = useState(defaultStyle);
  const fontSelectChange = (e) => {
    const idx = e.target.value - 1;
    if (items[idx]) {
      setFontStyle({ ...defaultStyle, ...items[idx].style });
    } else {
      setFontStyle({ ...defaultStyle });
    }
  };

  return (
    <>
      <select
        style={{
          height: "38px",
          width: "140px",
          border: "1px solid #000000",
          borderRadius: "0",
          outline: "none",
          padding: "0 4px",
        }}
        onChange={(e) => fontSelectChange(e)}
      >
        <option key="0" value="0">
          Weight
        </option>
        {items.map((item, idx) => (
          <option key={idx + 1} value={idx + 1}>
            {item.caption}
          </option>
        ))}
      </select>
      <div className="copy" style={{ marginTop: "80px" }}>
        <input
          type="text"
          className="darker-background"
          placeholder="Type something here to try Toyota Type"
          style={fontStyle}
        ></input>
      </div>
    </>
  );
};

export default FontSelector;
